// Author Liu Cui Cui
// Date 2022-07-08 14:26:47

import * as model from "@/model/sithMes/tpm/SithMesTpmProgramStatusTpsModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesTpmProgramStatusTps(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_TPM_URL,
    })
    .buildStore()
